// -----------------------
// Product Customizations
// -----------------------

// DOM Ready
function documentReady(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

const cr = {
  variantsSelected: function (type) {
    const variantSelectors = type === 'radio' 
      ? document.querySelector('variant-radios') 
      : document.querySelectorAll('variant-selects select');
    
    if (!variantSelectors) return [];
    
    const values = [];
    if (type === 'radio') {
      const fieldsets = variantSelectors.querySelectorAll('fieldset');
      fieldsets.forEach(fieldset => {
        const input = [...fieldset.querySelectorAll('input')].find(input => input.checked);
        if (input) values.push(input.getAttribute('value'));
      });
    } else {
      variantSelectors.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption) values.push(selectedOption.value);
      });
    }
    return values;
  },
  updateSelectedPrice: function (variantsSelected) {
    const matchingVariant = cr.matchingVariant(variants, variantsSelected);
    if (!matchingVariant) return;

    const compareAtPrice = parseInt(matchingVariant.compare_at_price);
    const regularPrice = parseInt(matchingVariant.price);
    const priceSaleElement = document.querySelector('.price__sale');
    if (!priceSaleElement) return;

    const salePriceElement = priceSaleElement.querySelector('.price-item--sale');
    const compareElement = priceSaleElement.querySelector('s.price-item--regular');
    if (salePriceElement) salePriceElement.textContent = `$${(regularPrice / 100).toFixed(2)}`;
    if (compareElement) compareElement.textContent = `$${(compareAtPrice / 100).toFixed(2)}`;
  },
  variantsOnChange: function (type) {
    const selectors = type === 'radio' 
      ? document.querySelectorAll('.product-form__input input[type="radio"]') 
      : document.querySelectorAll('.product-form__input select');
    
    if (!selectors.length) return;
    
    selectors.forEach(selector => {
      selector.addEventListener('change', () => {
        const selectedVariants = cr.variantsSelected(type);
        const matchingVariant = cr.matchingVariant(variants, selectedVariants);
        if (!matchingVariant) return;

        cr.updateProductPhoto(matchingVariant.featured_media.preview_image.src);
        const variantIdInput = document.querySelector('input.product-variant-id');
        if (variantIdInput) variantIdInput.value = matchingVariant.id;
        cr.updateSelectedPrice(selectedVariants);
      });
    });
  },
  matchingVariant: function (variants, variantsSelected) {
    return variants.find(variant => 
      variant.options.every((option, index) => option === variantsSelected[index])
    );
  },
  updateProductPhoto: function (imageUrl) {
    const slickSlides = document.querySelectorAll('.slick-slide');
    if (!slickSlides.length) return;

    const protocolRemovedSrc = imageUrl.replace('https:', '');
    slickSlides.forEach(slide => {
      const img = slide.querySelector('img');
      if (img && img.getAttribute('src') === protocolRemovedSrc) {
        const slideIndex = slide.getAttribute('data-slick-index');
        if (slideIndex) {
          $('.product-thumbs .js-slider-thumbs').slick('slickGoTo', slideIndex); // jQuery usage for .slick
        }
      }
    });
  },
  quantityChange: function () {
    const minButton = document.querySelector('.quantity-form .min');
    const plusButton = document.querySelector('.quantity-form .plus');
    const quantityInput = document.getElementById('Quantity');
    if (!minButton || !plusButton || !quantityInput) return;

    minButton.addEventListener('click', event => {
      event.preventDefault();
      const quantity = Math.max(1, parseInt(quantityInput.value) - 1);
      quantityInput.value = quantity;
    });

    plusButton.addEventListener('click', event => {
      event.preventDefault();
      const quantity = parseInt(quantityInput.value) + 1;
      quantityInput.value = quantity;
    });
  },
  product_slider: function () {
    const mainImageSliderElm = document.querySelector('.product-photo-container-slider');
    if (!mainImageSliderElm) return;

    const mainImageSplide = new Splide(mainImageSliderElm, {
      type: 'fade',
      perPage: 1,
      perMove: 1,
      arrows: false,
      pagination: false
    });

    const thumbsSplideElm = document.querySelector('.product-photo-thumbs-slider');
    let thumbsSplide = null;
    if (thumbsSplideElm) {
      thumbsSplide = new Splide(thumbsSplideElm, {
        perPage: 4,
        perMove: 1,
        pagination: false,
        arrows: false,
        isNavigation: true,
        direction: 'ltr',
        height: 'auto',
        gap: 10,
        breakpoints: {
          1024: { gap: 16, height: 'auto', direction: 'ltr' },
          768: { gap: 16, height: 'auto', direction: 'ltr' }
        }
      });
      mainImageSplide.sync(thumbsSplide);
    }

    mainImageSplide.mount();
    if (thumbsSplide) thumbsSplide.mount();

    const quotesSliderElm = document.querySelector('.quotes-slider');
    if (quotesSliderElm) {
      new Splide(quotesSliderElm, {
        perPage: 1,
        perMove: 1,
        pagination: true,
        arrows: false
      }).mount();
    }
  },
  handleVariantDropdown: function () {
    const productVariants = document.querySelector('.product-variants');
    if (!productVariants || productVariants.options.length <= 1) return;

    productVariants.classList.add('active');
    productVariants.addEventListener('change', event => {
      const selectedOption = event.target.options[event.target.selectedIndex];
      const onetimePriceElement = document.querySelector('.js-onetime-price');
      if (onetimePriceElement) {
        onetimePriceElement.innerHTML = selectedOption.getAttribute('data-onetime-price');
      }
    });
  },
  initDropdowns: function () {
    const dropdownButtons = document.querySelectorAll('.select-dropdown__button');
    const dropdownItems = document.querySelectorAll('.select-dropdown__list-item');

    if (dropdownButtons) {
      dropdownButtons.forEach(button => {
        button.addEventListener('click', () => {
          const dropdown = document.querySelector(`.product-flavors-dropdown[data-context="${button.dataset.context}"]`);
          dropdown.classList.toggle('active');
        });
      });
    }

    if (dropdownItems) {
      dropdownItems.forEach(item => {
        item.addEventListener('click', () => {
          const context = item.dataset.context;
          const buttonSpan = document.querySelector(`.select-dropdown__button[data-context="${context}"] span`);
          if (buttonSpan) buttonSpan.innerText = item.dataset.title;
        });
      });
    }
  },
  initSmoothScrolling: function () {
    const quickInfoButtons = document.querySelectorAll('.product-quick-info button');
    if (!quickInfoButtons.length) return;

    quickInfoButtons.forEach(button => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-target');
        if (targetId) {
          const targetElement = document.getElementById(targetId);
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    });
  },
  initAccordions: function() {
    const accordionSummaries = document.querySelectorAll('[id^="Details-"] summary');
    if (!accordionSummaries.length) return;

    accordionSummaries.forEach((summary) => {
      // Set initial ARIA attributes
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', 'false');

      const content = summary.nextElementSibling;
      if (content?.getAttribute('id')) {
        summary.setAttribute('aria-controls', content.id);
      }

      // Click handler
      summary.addEventListener('click', (event) => {
        const detailsElement = event.currentTarget.closest('details');
        if (!detailsElement) return;

        const isOpening = !detailsElement.hasAttribute('open');
        event.currentTarget.setAttribute('aria-expanded', isOpening);

        // Close other accordions if this one is opening
        if (isOpening) {
          this.closeOtherAccordions(detailsElement);
        }
      });

      // Escape key handler
      const details = summary.closest('details');
      if (details) {
        details.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() !== 'ESCAPE') return;
          
          const details = event.currentTarget;
          if (!details.hasAttribute('open')) return;

          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          summary.focus();
        });
      }
    });
  },
  closeOtherAccordions: function(currentAccordion) {
    const otherAccordions = document.querySelectorAll('[id^="Details-"]');
    otherAccordions.forEach((details) => {
      if (details === currentAccordion) return;
      
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    });
  },
  initZoom: function() {
    const zoomElements = document.querySelectorAll('.zoomable');
    if (!zoomElements.length) return;
    
    zoomElements.forEach(element => {
      element.addEventListener('mousemove', this.handleZoom);
      element.addEventListener('touchmove', this.handleZoom);
    });
  },
  handleZoom: function(e) {
    const zoomer = e.currentTarget;
    let offsetX, offsetY;

    if (e.offsetX) {
      offsetX = e.offsetX;
      offsetY = e.offsetY;
    } else {
      offsetX = e.touches[0].pageX - e.touches[0].target.offsetLeft;
      offsetY = e.touches[0].pageY - e.touches[0].target.offsetTop;
    }

    const x = (offsetX / zoomer.offsetWidth) * 100;
    const y = (offsetY / zoomer.offsetHeight) * 100;
    zoomer.style.backgroundPosition = `${x}% ${y}%`;
  },
  initProductModalDisplay: function() {
    if (window.innerWidth < 769) return;
    
    const imageWrappers = document.querySelectorAll('.product__image-wrapper');
    if (!imageWrappers) return;

    imageWrappers.forEach(element => {
      // Preload images
      const img = new Image();
      const zoomSrc = element.querySelector('img')?.getAttribute('data-zoom');
      if (zoomSrc) {
        img.src = zoomSrc;
        element.addEventListener('click', () => {
          const modal = document.getElementById('modal-overlay');
          if (modal) {
            modal.style.display = 'flex';
            this.loadModalImage(element);
          }
        });
      }
    });
  },
  loadModalImage: function(element) {
    const imgElement = element.querySelector('img');
    const imageSrc = imgElement?.getAttribute('data-zoom');
    if (!imageSrc) return;

    const modal = document.getElementById('modal-overlay');
    const modalImageWrapper = document.getElementById('modal-image-wrapper');
    const modalImg = document.getElementById('modalImage');
    
    if (modal && modalImg && modalImageWrapper) {
      modalImg.src = imageSrc;
      modalImageWrapper.style.backgroundImage = `url(${imageSrc})`;
      modalImageWrapper.addEventListener('mousemove', this.handleZoom);
      modalImageWrapper.addEventListener('touchmove', this.handleZoom);
    }
  },
  initProductModalClose: function() {
    const closeModal = document.querySelector('.close');
    if (!closeModal) return;

    closeModal.addEventListener('click', () => {
      const modal = document.getElementById('modal-overlay');
      if (!modal) return;

      modal.style.display = 'none';
      const modalImageWrapper = document.getElementById('modal-image-wrapper');
      if (modalImageWrapper) {
        modalImageWrapper.style.backgroundImage = '';
        modalImageWrapper.removeEventListener('mousemove', this.handleZoom);
        modalImageWrapper.removeEventListener('touchmove', this.handleZoom);
      }
    });
  },
  initProductFlavors: function() {
    const flavorSlider = document.querySelector('#product-flavors-slider');
    if (!flavorSlider) return;

    new Splide('#product-flavors-slider', {
      perPage: 4,
      gap: '8px',
      arrows: true,
      pagination: false,
      breakpoints: {
        768: {
          perPage: 3,
        }
      }
    }).mount();

    // Match flavor title heights
    const flavorTitles = document.querySelectorAll('.flavor-title');
    if (flavorTitles.length) {
      const maxHeight = Math.max(...Array.from(flavorTitles).map(el => el.offsetHeight));
      flavorTitles.forEach(title => title.style.height = `${maxHeight}px`);
    }
  },
};


// Page is Ready
documentReady(() => {
  cr.product_slider();
  cr.initDropdowns();
  cr.initSmoothScrolling();
  cr.handleVariantDropdown();
  cr.initAccordions();
  cr.initProductModalDisplay();
  cr.initProductModalClose();
  cr.initProductFlavors();
});